import type { KsecMeProduct } from '@/features/ksec/types'
import type { OrgProduct } from './types'

/**
 * Convierte los productos del contexto (/me/context → products).
 *
 * KSEC v3.0 puede devolver el mismo assetId (permission_public_id) para
 * distintos productos. Deduplicamos por nombre antes de mapear.
 */
export function mapContextProducts(contextProducts: KsecMeProduct[]): OrgProduct[] {
  const seen = new Map<string, KsecMeProduct>()
  for (const p of contextProducts) {
    if (!seen.has(p.name)) seen.set(p.name, p)
  }

  return Array.from(seen.values()).map((p) => ({
    asset: {
      id:     p.assetId,
      name:   p.name,
      type:   p.type,
      status: 1,  // se asume ACTIVE (1)
    },
    userRoles:     p.userRoles,
    isCurrentPortal: p.name.toLowerCase().includes('portal empresa'),
    isEmbedded:    false,
    portal_url:    p.portal_url    ?? null,
    offering_name: p.offering_name ?? null,
    offering_id:   p.offering_id   ?? null,
  }))
}
